<div class="row">
    <div class="col-lg-4">
        <div class="title-box text-center text-lg-start">
            <div class="wow pulse" data-wow-iteration="2" data-wow-duration="0.2">
                <h3 class="text-info">Get In Touch</h3>
                <p class="text-primary h6">Fill in your details below to arrange a call and discover more about us.</p>
            </div>
            <img [src]="'assets/images/home/form-dog.png'" alt="" class="img-fluid mt-4 d-none d-lg-block">
        </div>
    </div>
    <div class="col-lg-4">
        <div class="loc-box mb-4 w-100 wow zoomIn" data-wow-delay="0.5s">
            <h4 class="mb-4 text-primary">League City</h4>
            <div class="mb-4">
                <div class="sub-title">Email</div>
                <a href="mailto:frontdesk@safarivet.com">frontdesk&#64;safarivet.com</a>
            </div>
            <div class="d-flex justify-content-between my-3 flex-xl-row flex-column">
                <div>
                    <div class="sub-title">Phone Number</div>
                    <a href="tel:281-332-5612">281-332-5612</a>
                </div>
                <div>
                    <div class="sub-title">Fax</div>
                    <a href="tel:801-303-7066">801-303-7066</a>
                </div>
            </div>
            <div>
                <div class="sub-title">Address</div>
                <span (click)="gotToMap('2402 Marina Bay Dr,League City, TX 77573, USA');" class="cursor-pointer">2402
                    Marina Bay Dr,League City, TX 77573, USA</span>
            </div>
        </div>
    </div>
    <div class="col-lg-4">
        <div class="loc-box mb-4 w-100 wow zoomIn" data-wow-delay="1s">
            <h4 class="mb-4 text-primary">Pearland</h4>
            <div class="mb-4">
                <div class="sub-title">Email</div>
                <a href="mailto:pearland@safarivet.com">pearland&#64;safarivet.com</a>
            </div>
            <div class="d-flex justify-content-between my-3 flex-xl-row flex-column">
                <div>
                    <div class="sub-title">Phone Number</div>
                    <a href="tel:346-688-7678">346-688-7678</a>
                </div>
                <div>
                    <div class="sub-title">Fax</div>
                    <a href="tel:801-303-7066">801-303-7066</a>
                </div>
            </div>
            <div>
                <div class="sub-title">Address</div>
                <span (click)="gotToMap('3525 South Main Suite 118, Pearland, TX 77581');" class="cursor-pointer">3525
                    South Main Suite 118, Pearland, TX 77581</span>
            </div>
        </div>
    </div>
    <hr class="seperator">
</div>
<div class="row">
    <div class="col-12">
        <div class="form-box d-flex overflow-hidden rounded-4 mt-4 align-items-stretch">
            <div class="left-box d-xl-flex d-none align-items-end">
                <img [src]="'assets/images/home/form-left-dog.png'" alt="">
            </div>
            <div class="right-box p-md-5 p-3 w-100 ">
                <form class="contct-form" [formGroup]="contactUsForm" (ngSubmit)="submitContactDetail()">
                    <div class="row">
                        <div class="col-lg-6 mb-4">
                            <input type="text" trim="blur" id="name" name="name" [formControl]="name" placeholder="Name"
                                class="form-control">

                            @if((name?.touched || name?.dirty || submitted ) && !name?.valid && !name?.pending){
                            @if(name?.errors?.required){
                            <span class="text-danger error">Name is required</span>
                            }
                            }

                        </div>
                        <div class="col-lg-6 mb-4">
                            <input type="text" trim="blur" id="email" name="email" [formControl]="email"
                                placeholder="Email" class="form-control">

                            @if((email?.touched || email?.dirty || submitted) &&!email?.valid &&!email?.pending){

                            @if(email?.errors.required){
                            <span class="text-danger error">
                                Email is required
                            </span>
                            }

                            @if(email?.errors.pattern){
                            <span class="text-danger error">
                                Please enter valid email address
                            </span>
                            }
                            }

                        </div>
                        <div class="col-lg-6 mb-4">
                            <input type="text" trim="blur" id="phone_no" name="phone_no" [formControl]="phone_no"
                                placeholder="Phone Number" class="form-control">


                            @if((phone_no?.touched || phone_no?.dirty) && !phone_no?.valid && !phone_no?.pending){
                            <span class="text-danger error">
                                @if(phone_no?.errors.pattern){
                                Please enter numerals only (no-dashes) <br />
                                }
                                @if(phone_no?.errors.minlength){
                                Phone number should be minimum 6 digits
                                }
                                @if(phone_no?.errors.maxlength){
                                Phone number not allow more than 15 digits
                                }
                            </span>
                            }

                        </div>
                        <div class="col-lg-6 mb-4">
                            <input type="text" trim="blur" id="pet_bread" name="pet_bread" [formControl]="pet_breed"
                                placeholder="Pet Breed" class="form-control">
                        </div>
                        <div class="col-lg-6 mb-4">
                            <input type="text" trim="blur" id="pet_name" name="pet_name" [formControl]="pet_name"
                                placeholder="Pet Name" class="form-control">
                        </div>
                        <div class="col-lg-6 mb-4">
                            <input type="text" trim="blur" id="pet_age" name="pet_age" [formControl]="pet_age"
                                placeholder="Age" class="form-control">

                            @if((pet_age?.touched || pet_age?.dirty) &&!pet_age?.valid &&!pet_age?.pending){
                            @if(pet_age?.errors.pattern){
                            <span class="text-danger error">
                                Numbers only
                            </span>
                            }
                            }

                        </div>
                        <div class="col-12 mb-4">
                            <ng-select id="plan" class="form-control input-select" dropdownPosition="bottom"
                                [items]="plans" bindLabel="name" bindValue="id" [searchable]="false"
                                placeholder="Select Subscription Plan" [formControl]="pet_subscription_plan">
                            </ng-select>
                        </div>
                        <div class="col-12 mb-4">
                            <textarea id="message" name="name" rows="4" [formControl]="message" class="form-control"
                                placeholder="Message"></textarea>

                            @if((message?.touched || message?.dirty || submitted) &&!message?.valid &&
                            !message?.pending){

                            @if(message?.errors.required){
                            <span class="text-danger error">Message is
                                required</span>
                            }
                            }

                        </div>
                        <div class="col-12">
                            <div class="d-flex justify-content-between align-items-start flex-column flex-md-row">

                                @if(reCaptchaSiteKey){
                                <span>
                                    <re-captcha (resolved)="submitCaptcha($event)" #recaptchaRef
                                        siteKey="{{ reCaptchaSiteKey }}"></re-captcha>

                                    @if(submitted && !isCaptchaValid){
                                    <span class="text-danger error float-left">Please validate captcha</span>
                                    }

                                </span>
                                }

                                <button class="btn btn-success mt-4 mt-md-0" type="submit" name="button"
                                    [ladda]="isSubmit">Submit</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>